exports = module.exports = require("../../../_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".van-tab__pane,\n.van-tab__pane-wrapper {\n  -webkit-flex-shrink: 0;\n  flex-shrink: 0;\n  box-sizing: border-box;\n  width: 100%;\n}\n\n.van-tab__pane-wrapper--inactive {\n  height: 0;\n  overflow: visible;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.28.11@css-loader?{"minimize":false,"sourceMap":false}!./~/_px2rem-loader@0.1.9@px2rem-loader?{"remUnit":37.5}!./~/_vant@2.13.2@vant/lib/tab/index.css
// module id = 234
// module chunks = 320 321